import React from "react";
import { LockClosedIcon } from "@heroicons/react/24/outline";
import { StageColumn } from "../../config/offeringCatalog";
import {
  CURRENT_COLUMN_TINT,
  stageAccentTextClasses,
  stageSolidBgClasses,
  YOU_ARE_HERE_PILL,
} from "../../config/accentStyles";

interface StageHeaderCellProps {
  column: StageColumn;
  total: number;
  isCurrent: boolean;
  isLocked: boolean;
}

const StageHeaderCell: React.FC<StageHeaderCellProps> = ({
  column,
  total,
  isCurrent,
  isLocked,
}) => {
  const accentText = stageAccentTextClasses[column.position];

  return (
    <div
      className={[
        "relative flex flex-col items-center gap-1 px-3 py-5 text-center",
        "border-l border-gray-200 dark:border-slate-700",
        isCurrent ? CURRENT_COLUMN_TINT : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {isLocked && (
        <LockClosedIcon
          aria-label="Higher stage"
          className="absolute right-3 top-3 h-3.5 w-3.5 text-gray-400 opacity-50 dark:text-slate-400"
        />
      )}

      {isCurrent ? (
        <span
          className={`mb-1 inline-flex items-center gap-1 rounded-xl px-2.5 py-1 text-[9px] font-bold uppercase tracking-[0.08em] ${YOU_ARE_HERE_PILL}`}
        >
          <span aria-hidden="true">&#9662;</span>
          You Are Here
        </span>
      ) : (
        <span aria-hidden="true" className="mb-1 h-[22px]" />
      )}

      <span
        className={`flex h-[26px] w-[26px] items-center justify-center rounded-full text-[13px] font-bold text-slate-900 ${stageSolidBgClasses[column.position]}`}
      >
        {column.position}
      </span>

      <span className="text-[17px] font-bold text-gray-900 dark:text-slate-100">
        {column.label}
      </span>
      <span className={`text-[11px] font-medium ${accentText}`}>
        {column.persona}
      </span>
      <span className="text-[10.5px] tracking-wide text-gray-500 dark:text-slate-400">
        {column.businessSize}
      </span>

      <span
        className={`mt-2 text-[26px] font-extrabold leading-none ${accentText}`}
      >
        {total}
      </span>
      <span className="text-[8.5px] font-bold uppercase tracking-[0.12em] text-gray-500 dark:text-slate-400">
        Total Offerings
      </span>
    </div>
  );
};

export default StageHeaderCell;
